import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import OwnerPortal from './components/OwnerPortal'
import { SiteDataProvider } from './context/fetchContext'
import Popup from './components/Popup'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <BrowserRouter>
    {/* <React.StrictMode> */}
    <SiteDataProvider>
      <Popup />
      <OwnerPortal />
      <App />
    </SiteDataProvider>
    {/* </React.StrictMode> */}
  </BrowserRouter>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
